export const OPERATIONS = Object.freeze({
  max: 'Massimo',
  min: 'Minimo',
  avg: 'Media',
  sum: 'Somma',
})

export const OPERATIONS_KEYS = Object.keys(OPERATIONS)